export const CSRF_HEADER_NAME = 'x-csrf-token';

export const MAX_TRIES_COUNT = 2;
